import { CheckoutPaymentSchedule, Promotion } from '@afterpaytouch/portal-api'

export const enrichPaymentSchedules = (
  oldPaymentSchedule: CheckoutPaymentSchedule[],
  promotion: Promotion | null,
  newPaymentSchedules: CheckoutPaymentSchedule[]
): { paymentSchedules: CheckoutPaymentSchedule[]; promotion: Promotion | null } => {
  if (promotion != null) {
    promotion = {
      ...promotion,
      orderDiscountedPaymentSchedules: promotion.orderDiscountedPaymentSchedules.map((schedule, idx) => ({
        ...schedule,
        installmentDueDate: newPaymentSchedules[idx].installmentDueDate,
      })),
    }
  }

  const paymentSchedules = oldPaymentSchedule.map((schedule, idx) => ({
    ...schedule,
    installmentDueDate: newPaymentSchedules[idx].installmentDueDate,
  }))

  return {
    paymentSchedules,
    promotion,
  }
}
